import React, { useCallback, useEffect, useState } from "react"
import { useContextSelector as useCS } from "use-context-selector"

import { useTitle } from "domain/application/hooks/useTitle"
import {
  TransactionContext,
  TransactionProvider,
} from "domain/transaction/TransactionContext"
import { transactionSelectors } from "domain/transaction/selectors"
import { GridContainer } from "domain/core/containers/GridContainer"
import { dataToRow } from "domain/transaction/mappers"
import { GridStateStoreContainer } from "domain/core/containers/GridStateStoreContainer"
import { PermissionsEnum } from "domain/rbac/PermissionsEnum"
import { AccessPageContainer } from "domain/core/containers/AccessPageContainer"
import { mapGridContainerParamsToReq } from "domain/core/mappers"

import { DownloadReportButton } from "view/components/DownloadReportButton"

import { usePrepareTransactionDictionaries } from "./hooks/usePrepareTransactionDictionaries"
import {
  mergeDictionariesWithFilters,
  mapToTransactionFilterReq,
} from "./mappers"
import { filterItems } from "./config"
import { columnsConfig } from "./columns.config"

const Page = () => {
  const [initParams, setInitParams] = useState(null)

  const { dictionaries } = usePrepareTransactionDictionaries()

  const [selectedRow, setSelectedRow] = useState([])

  const gridData = useCS(TransactionContext, transactionSelectors.gridData)

  useEffect(() => {
    if (!dictionaries) return
    if (initParams) return

    setInitParams({
      filters: {
        items: mergeDictionariesWithFilters(filterItems, dictionaries),
      },
      sort: [
        {
          columnName: "startedAt",
          direction: "desc",
        },
      ],
    })
  }, [dictionaries])

  const handlerRowClick = useCallback((ids) => {
    setSelectedRow(ids)
  }, [])

  if (!initParams) return null

  return (
    <>
      <GridStateStoreContainer
        selectors={transactionSelectors}
        context={TransactionContext}
        filterToState={mapToTransactionFilterReq}
        storageGridKey="transactionsList"
      />

      <GridContainer
        url="/v1/transactions/list"
        columns={columnsConfig()}
        dataToRow={dataToRow}
        filterToReq={mapToTransactionFilterReq}
        selectors={transactionSelectors}
        context={TransactionContext}
        initParams={initParams}
        onRowClick={handlerRowClick}
        selectedRows={selectedRow}
        TopRightContent={
          <DownloadReportButton
            name="transactions"
            url="/v1/transactions/download"
            fileName="Transactions"
            params={mapGridContainerParamsToReq(
              gridData,
              mapToTransactionFilterReq
            )}
          />
        }
      />
    </>
  )
}

export const TransactionListPage = () => {
  useTitle("Transactions")

  return (
    <AccessPageContainer permissions={[PermissionsEnum.FinancereportView]}>
      <TransactionProvider>
        <Page />
      </TransactionProvider>
    </AccessPageContainer>
  )
}
